export default __webpack_public_path__ + "static/pump_b.47471066c9c3ad5b88c5b4a24e52c2b1.svg";